import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const ABOUT_IMG = 'https://cdn.magicpatterns.com/uploads/cGrBZu93equr27XKf7Kq1W/lukman-hidayah-ZYcTVAOzxgA-unsplash.jpg';
export function About() {
  const bullets = ['Free and affordable government resources', 'Inclusive, community-first approach', 'Live appointment-based service', 'Multiple national locations'];
  return <section id="about" className="bg-brand-cream py-16 md:py-24" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-15">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="relative order-2 lg:order-1 px-4 lg:px-0" data-id="element-16">
            <div className="relative rounded-lg overflow-hidden border-4 border-brand-gold/30 shadow-xl" data-id="element-17">
              <img src={ABOUT_IMG} alt="Community outreach" className="w-full h-auto object-cover aspect-[4/3] lg:aspect-auto lg:h-[600px]" data-id="element-18" />
              <div className="absolute inset-0 bg-brand-gold/10 mix-blend-overlay" data-id="element-19"></div>
            </div>

            {/* Floating Badge */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4,
            type: 'spring'
          }} className="absolute -bottom-6 -right-2 lg:-right-6 bg-brand-gold text-brand-black font-bold py-3 px-6 rounded shadow-lg border-2 border-white" data-id="element-20">
              EST. 2009
            </motion.div>
          </motion.div>

          {/* Content Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="order-1 lg:order-2 flex flex-col" data-id="element-21">
            <p className="text-brand-gold font-bold tracking-widest uppercase text-sm mb-4" data-id="element-22">
              Who We Are
            </p>
            <h2 className="text-brand-black text-[32px] md:text-[42px] leading-tight font-serif mb-6" data-id="element-23">
              A Resource Center for Every Household
            </h2>
            <p className="text-brand-charcoal/80 text-base md:text-lg mb-8 leading-relaxed" data-id="element-24">
              Prime Nation stands as a comprehensive resolution center,
              dedicated to delivering free and affordable government resources
              to communities across the country. Our commitment goes beyond
              essential services. We actively foster a diverse, inclusive
              workforce and run impactful outreach programs that put real tools
              in real hands. Since 2009, we've proudly led the way, treating
              every person who walks through our doors with respect, dignity,
              and the service they deserve.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-25">
              {bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-26">
                  <CheckCircle2 className="text-brand-gold shrink-0 mt-0.5" size={20} data-id="element-27" />
                  <span className="text-brand-charcoal font-medium" data-id="element-28">
                    {bullet}
                  </span>
                </li>)}
            </ul>

            <div data-id="element-29">
              <button className="w-full md:w-auto bg-brand-black text-brand-gold px-8 py-4 rounded font-bold text-base hover:bg-gray-900 transition-colors min-h-[48px]" data-id="element-30">
                Learn More About Us
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}